import ActivityStatus from '../enums/activities/ActivityStatus.ts';

export const ReconciliationViewStatuses = [
  ActivityStatus.PreReconciliation,
  ActivityStatus.IssueReconciliation,
  ActivityStatus.Reconciled
];

export const ReconciliationEditStatuses = [
  ActivityStatus.PreReconciliation,
  ActivityStatus.IssueReconciliation,
  ActivityStatus.Reconciled
];
